import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { api_url } from "../config/config";

const OrderTransferHistory = () => {
  const [transfers, setTransfers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    fetchOrderTransferHistory();
  }, [searchTerm]);

  const fetchOrderTransferHistory = async () => {
    try {
      const response = await axios.get(
        `${api_url}/transfer-order?search=${searchTerm}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
          },
        }
      );

      const rawData = response.data.data || []; 
      setTransfers(rawData);
    } catch (error) {
      console.error("Error fetching order transfers:", error);
    }
  };

  return (
    <div className="flex flex-col">
      <div className="flex-grow overflow-auto">
        <h2 className="text-2xl font-bold mb-4 mt-7">Order Transfer History</h2>
        <div className="bg-white p-6 rounded-lg shadow-lg">
          <div className="w-full flex items-center justify-between gap-5 mb-4">
            <input
              type="text"
              className="border rounded-xl border-slate-700 p-2 w-[300px] px-3"
              placeholder="Search by Order ID, Branch, Admin"
              title="Search by Order ID, Branch, Admin"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <table className="table-auto w-full text-sm text-left">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-6 py-3">Order ID</th>
                <th className="px-6 py-3">From Branch</th>
                <th className="px-6 py-3">To Branch</th>
                <th className="px-6 py-3">Transferred By</th>
                <th className="px-6 py-3">Date</th>
              </tr>
            </thead>
            <tbody>
              {transfers.length === 0 ? (
                <tr>
                  <td colSpan={5} className="text-center py-8 text-gray-500">
                    No transfer records found.
                  </td>
                </tr>
              ) : (
                transfers.map((transfer) => (
                  <tr key={transfer.id} className="hover:bg-gray-100">
                    <td className="px-6 py-3">{transfer.orderId}</td>
                    <td className="px-6 py-3">
                      {transfer.from_branch?.area || "N/A"}
                      <br />
                      <span className="text-xs text-gray-500">
                        {transfer.from_branch?.pincode}
                      </span>
                    </td>
                    <td className="px-6 py-3">
                      {transfer.to_branch?.area || "N/A"}
                      <br />
                      <span className="text-xs text-gray-500">
                        {transfer.to_branch?.pincode}
                      </span>
                    </td>
                    <td className="px-6 py-3">
                      {transfer.transferredByAdmin?.name || "N/A"}
                      <br />
                      <span className="text-xs text-gray-500">
                        {transfer.transferredByAdmin?.designation}
                      </span>
                    </td>
                    <td className="px-6 py-3">
                      {new Date(transfer.createdAt).toLocaleString()}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default OrderTransferHistory;
